import { SHOW_NOTIFICATION } from './NotificationActionType'

export const initialState = {
  isShown: false,
  message: '',
}

export default function notificationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const { payload } = action
      const { isShown, message, type, autoHideDuration } = payload
      const newState = {
        ...state,
        isShown,
        message,
        type,
        autoHideDuration,
      }
      return newState
    }
    default:
      return state
  }
}
